const transmissionMethods = [
  'Paper',
  'Electronically',
  'Third Party',
];

export default transmissionMethods;



// WEBPACK FOOTER //
// ./src/config/transmissionMethods.js